import {
  CLEAR_PRODUCT_TILES,
  FETCH_PRODUCT_TILE,
  FETCH_PRODUCT_TILE_BY_BARCODE,
  FETCH_PRODUCT_TILE_FULFILLED,
  FETCH_PRODUCT_TILE_REJECTED,
  FETCH_PRODUCT_TILES,
  FETCH_PRODUCT_TILES_FULFILLED,
  FETCH_PRODUCT_TILES_REJECTED,
} from 'b2b-apps/shop/product/redux/products/tile/actionTypes';
import {
  ClearProductTilesAction,
  FetchProductTileAction,
  FetchProductTileByBarcodeAction,
  FetchProductTileFulfilledAction,
  FetchProductTileRejectedAction,
  FetchProductTilesAction,
  FetchProductTilesFulfilledAction,
  FetchProductTilesRejectedAction,
  ProductTilesType,
  ProductTileType,
} from 'b2b-apps/shop/product/redux/products/tile/types';

const fetchProductTile = (sku: string): FetchProductTileAction => ({
  type: FETCH_PRODUCT_TILE,
  payload: {
    sku,
  },
});

const fetchProductTileByBarcode = (
  barcode: string,
): FetchProductTileByBarcodeAction => ({
  type: FETCH_PRODUCT_TILE_BY_BARCODE,
  payload: {
    barcode,
  },
});

const fetchProductTileFulfilled = (
  sku: string,
  data: ProductTileType,
): FetchProductTileFulfilledAction => ({
  type: FETCH_PRODUCT_TILE_FULFILLED,
  payload: {
    data,
    sku,
  },
});

const fetchProductTileRejected = (
  sku: string,
  error: ErrorType,
): FetchProductTileRejectedAction => ({
  type: FETCH_PRODUCT_TILE_REJECTED,
  payload: {
    error,
    sku,
  },
});

const clearProductTiles = (): ClearProductTilesAction => ({
  type: CLEAR_PRODUCT_TILES,
});

const fetchProductTiles = (
  skus: string[],
  groupNumber: number,
): FetchProductTilesAction => ({
  type: FETCH_PRODUCT_TILES,
  payload: {
    groupNumber,
    skus,
  },
});

const fetchProductTilesFulfilled = (
  skus: string[],
  data: ProductTilesType,
): FetchProductTilesFulfilledAction => ({
  type: FETCH_PRODUCT_TILES_FULFILLED,
  payload: {
    data,
    skus,
  },
});


const fetchProductTilesRejected = (
  skus: string[],
  error: ErrorType,
): FetchProductTilesRejectedAction => ({
  type: FETCH_PRODUCT_TILES_REJECTED,
  payload: {
    error,
    skus,
  },
});

export {
  clearProductTiles,
  fetchProductTile,
  fetchProductTileByBarcode,
  fetchProductTileFulfilled,
  fetchProductTileRejected,
  fetchProductTiles,
  fetchProductTilesFulfilled,
  fetchProductTilesRejected,
};
